<script setup>

import { computed, ref } from "vue";
import useUsuarioStore from "@stores/UsuarioStore.js";
import useColaboradorStore from "@stores/ColaboradorStore.js";
import CartaoListaDeDados from "./ListaDeDados/CartaoListaDeDados.vue";
import ModalVisualizarDados from "./VisualizarDados/ModalVisualizarDados.vue";
import ModalPreencherDadosComercial from "./PreencherDadosComercial/ModalPreencherDadosComercial.vue";
import ModalPreencherDadosGestor from "./PreencherDadosGestor/ModalPreencherDadosGestor.vue";
import ModalPreencherDadosCoordenador from "./PreencherDadosCoordenador/ModalPreencherDadosCoordenador.vue";
import ModalRevisarDados from "./RevisarDados/ModalRevisarDados.vue";
import ModalCancelarDados from "./CancelarDados/ModalCancelarDados.vue";

//==================================================================//
//=========================== User Store ===========================//
//==================================================================//

const usuarioStore = useUsuarioStore();

//==================================================================//
//======================== Colaborador Store =======================//
//==================================================================//

const colaboradorStore = useColaboradorStore(); 

//==================================================================//
//====================== Controles Desativados =====================//
//==================================================================//

const controlesDesativados = ref(false);

//==================================================================//
//====================== Dados Originais ===========================//
//==================================================================//

const dadosOriginais = ref([]);

//==================================================================//
//======================= Dados Original ===========================//
//==================================================================//

const dadoOriginal = ref({});

// //==================================================================//
// //====================== Visualizando Dado =========================//
// //==================================================================//

const visualizandoDado = ref(false);

//==================================================================//
//================ Preenchendo Dado Coemrcial ======================//
//==================================================================//

const preenchendoDadoComercial = ref(false);

//==================================================================//
//================== Preenchendo Dado Gestor =======================//
//==================================================================//

const preenchendoDadoGestor = ref(false);

//==================================================================//
//=============== Preenchendo Dado Coordenador =====================//
//==================================================================//

const preenchendoDadoCoordenador = ref(false);

//==================================================================//
//====================== Revisando Dado ============================//
//==================================================================//

const revisandoDado = ref(false);

//==================================================================//
//====================== Cancelando Dado ===========================//
//==================================================================//

const cancelandoDado = ref(false);

//==================================================================//
//====================== Acesso de Usuario =========================//
//==================================================================//

    // ACESSA TELA DE COMERCIAL 

        // GRUPO DE COMERCIAL SOBRESSALENTES GESTOR
            // Grupo: Comercial Sobressalentes - Supervisor
                // User: JESSICA LIMA DA SILVA

        // GRUPO DE COMERCIAL SOBRESSALENTES
            // Grupo: Comercial Sobressalentes - Operação
                // User: BIANCA GOMES DE SOUZA

        // GRUPO DE COMERCIAL 
            // Grupo: Comercial - Supervisor
                // User: KARINA NOGUEIRA BUENO
            // Grupo: Comercial Vendedores
                // User: CARLOS EDUARDO CAMPOS DE FREITAS
                // User: MARCELO RODRIGUES DOS SANTOS
                // User: MILTON CHIGA
                // User: CLAYTON FABIANO FERREIRA LEITE
                // User: FELIPE GIUDICE STELLA
                // User: FERNANDO MARANIM SANDOVAL

        // GRUPO DE ALMOXARIFADO
            // Grupo: Fabrica Almoxarifado - Supervisão
                // User: CAIQUE WESLEY CAMARGO

    // ACESSA TELA DE GESTOR

        // GRUPO DE COMERCIAL SOBRESSALENTES GESTOR
            // Grupo: Comercial Sobressalentes - Supervisor
                // User: JESSICA LIMA DA SILVA

        // GRUPO DE GESTOR
            // Grupo: Coordenação Contratos - Supervisor
                // User: RAPHAEL HENRIQUE AGUIAR DA SILVA

        // GRUPO DE ALMOXARIFADO
            // Grupo: Fabrica Almoxarifado - Supervisão
                // User: CAIQUE WESLEY CAMARGO

    // ACESSA TELA DE COORDENADOR

        // GRUPO DE COMERCIAL SOBRESSALENTES GESTOR
            // Grupo: Comercial Sobressalentes - Supervisor
                // User: JESSICA LIMA DA SILVA

        // GRUPO DE COORDENADOR
            // Grupo: Coordenação Contratos - Operação
                // User: FELIPE DA SILVA RIBEIRO MARIANO
                // User: KEVIN LAITA KUMAMOTO

         // GRUPO DE COMERCIAL SOBRESSALENTES
            // Grupo: Comercial Sobressalentes - Operação
                // User: BIANCA GOMES DE SOUZA

        // GRUPO DE ALMOXARIFADO
            // Grupo: Fabrica Almoxarifado - Supervisão
                // User: CAIQUE WESLEY CAMARGO

const usuarioGrupo = computed(()=>{

    switch(usuarioStore?.usuario?.grupoNome){
        case "Administradores":
        case "Diretoria Executivo":
            return "Administrador";
        case "Comercial Sobressalentes - Supervisor":
            return "Comercial Sobressalente Gestor"
        case "Comercial Sobressalentes - Operação": 
            return "Comercial Sobressalente";
        case "Comercial - Supervisor":
        case "Comercial Vendedores":
            return "Comercial";
        case "Coordenação Contratos - Supervisor":
            return "Gestor";
        case "Coordenação Contratos - Operação":
            return "Coordenador";
        case "Fabrica Almoxarifado - Supervisão":
            return "Almoxarifado";
        default:
            return "Padrão";
    }

});

//==================================================================//
//================= Altera Controles Desativados ===================//
//==================================================================//

const alteraControlesDesativados = (update = false)=>{

    controlesDesativados.value = update;

};

//==================================================================//
//=================== Altera Dados Originais =======================//
//==================================================================//

const alteraDadosOriginais = (update=[])=>{

    dadosOriginais.value = update;

};

//==================================================================//
//==================== Altera Dado Original ========================//
//==================================================================//

const alteraDadoOriginal = (update={})=>{

    dadoOriginal.value = update

};

//==================================================================//
//=================== Altera Visualizando Dado =====================//
//==================================================================//

const alteraVisualizandoDado = (update={})=>{

    alteraDadoOriginal(update?.dado || {});
    visualizandoDado.value = update?.modal || false;

};

//==================================================================//
//============== Altera Preenchendo Dado Comercial =================//
//==================================================================//

const alteraPreenchendoDadoComercial = (update={})=>{

    alteraDadoOriginal(update?.dado || {});
    preenchendoDadoComercial.value = update?.modal || false;

};

//==================================================================//
//================ Altera Preenchendo Dado Gestor ==================//
//==================================================================//

const alteraPreenchendoDadoGestor = (update={})=>{

    alteraDadoOriginal(update?.dado || {});
    preenchendoDadoGestor.value = update?.modal || false;

};

//==================================================================//
//============= Altera Preenchendo Dado Coordenador ================//
//==================================================================//

const alteraPreenchendoDadoCoordenador = (update={})=>{

    alteraDadoOriginal(update?.dado || {});
    preenchendoDadoCoordenador.value = update?.modal || false;

};

//==================================================================//
//======================= Altera Revisando Dado ====================//
//==================================================================//

const alteraRevisandoDado = (update={})=>{

    alteraDadoOriginal(update?.dado || {});
    revisandoDado.value = update?.modal || false;

};

//==================================================================//
//====================== Altera Cancelando Dado ====================//
//==================================================================//

const alteraCancelandoDado = (update={})=>{

    alteraDadoOriginal(update?.dado || {});
    cancelandoDado.value = update?.modal || false;

};

</script>

<template>

    <main
        class="c-main"
        :class="{ 'c-main--disabled': controlesDesativados }"
    >

        <h2>Jobs</h2>

        <CartaoListaDeDados
            :usuarioStore="usuarioStore"
            :colaboradorStore="colaboradorStore"
            :usuarioGrupo="usuarioGrupo"
            :dadosOriginais="dadosOriginais"
            :dadoOriginalSelecionado="dadoOriginal"
            :visualizandoDado="visualizandoDado"
            :preenchendoDadoComercial="preenchendoDadoComercial"
            :preenchendoDadoGestor="preenchendoDadoGestor"
            :preenchendoDadoCoordenador="preenchendoDadoCoordenador"
            :revisandoDado="revisandoDado"
            :cancelandoDado="cancelandoDado"
            :controlesDesativados="controlesDesativados"
            @update:alteraControlesDesativados="alteraControlesDesativados"
            @update:alteraDadosOriginais="alteraDadosOriginais"
            @update:alteraVisualizandoDado="alteraVisualizandoDado"
            @update:alteraPreenchendoDadoComercial="alteraPreenchendoDadoComercial"
            @update:alteraPreenchendoDadoGestor="alteraPreenchendoDadoGestor"
            @update:alteraPreenchendoDadoCoordenador="alteraPreenchendoDadoCoordenador"
            @update:alteraRevisandoDado="alteraRevisandoDado"
            @update:alteraCancelandoDado="alteraCancelandoDado"
        ></CartaoListaDeDados>
        
        <ModalVisualizarDados
            :usuarioStore="usuarioStore"
            :colaboradorStore="colaboradorStore"
            :dadoOriginal="dadoOriginal"
            :visualizandoDado="visualizandoDado"
            :controlesDesativados="controlesDesativados"
            @update:alteraControlesDesativados="alteraControlesDesativados"
            @update:alteraVisualizandoDado="alteraVisualizandoDado"
        ></ModalVisualizarDados>

        <ModalPreencherDadosComercial
            :usuarioStore="usuarioStore"
            :colaboradorStore="colaboradorStore"
            :dadoOriginal="dadoOriginal"
            :preenchendoDadoComercial="preenchendoDadoComercial"
            :controlesDesativados="controlesDesativados"
            @update:alteraControlesDesativados="alteraControlesDesativados"
            @update:alteraPreenchendoDadoComercial="alteraPreenchendoDadoComercial"
        ></ModalPreencherDadosComercial>

        <ModalPreencherDadosGestor
            :usuarioStore="usuarioStore"
            :colaboradorStore="colaboradorStore"
            :dado="dadoOriginal"
            :preenchendoDadoGestor="preenchendoDadoGestor"
            :controlesDesativados="controlesDesativados"
            @update:alteraDado="alteraDadoOriginal"
            @update:alteraControlesDesativados="alteraControlesDesativados"
            @update:alteraPreenchendoDadoGestor="alteraPreenchendoDadoGestor"
        ></ModalPreencherDadosGestor>

        <ModalPreencherDadosCoordenador
            :usuarioStore="usuarioStore"
            :colaboradorStore="colaboradorStore"
            :dado="dadoOriginal"
            :preenchendoDadoCoordenador="preenchendoDadoCoordenador"
            :controlesDesativados="controlesDesativados"
            @update:alteraDado="alteraDadoOriginal"
            @update:alteraControlesDesativados="alteraControlesDesativados"
            @update:alteraPreenchendoDadoCoordenador="alteraPreenchendoDadoCoordenador"
        ></ModalPreencherDadosCoordenador>

        <ModalRevisarDados
            :usuarioStore="usuarioStore"
            :colaboradorStore="colaboradorStore"
            :dado="dadoOriginal"
            :revisandoDado="revisandoDado"
            :controlesDesativados="controlesDesativados"
            @update:alteraDado="alteraDadoOriginal"
            @update:alteraControlesDesativados="alteraControlesDesativados"
            @update:alteraRevisandoDado="alteraRevisandoDado"
        ></ModalRevisarDados>

         <ModalCancelarDados
            :usuarioStore="usuarioStore"
            :colaboradorStore="colaboradorStore"
            :dadoOriginal="dadoOriginal"
            :cancelandoDado="cancelandoDado"
            :controlesDesativados="controlesDesativados"
            @update:alteraControlesDesativados="alteraControlesDesativados"
            @update:alteraCancelandoDado="alteraCancelandoDado"
        ></ModalCancelarDados>

    </main>

</template>

<style scoped>

.c-main{
    display: grid;
    gap: 15px;
}

.c-main--disabled{
    pointer-events: none;
    user-select: none; 
}

</style>